/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Audit_Details_Integration_Revoked_External_Failed_DescInputs */



/**
* | output |
* | --- |
* | "Access to the {provider} integration was revoked locally, but revoking it on the {provider} side failed. Check the connection." |
*
* @param {Audit_Details_Integration_Revoked_External_Failed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_integration_revoked_external_failed_desc = /** @type {((inputs: Audit_Details_Integration_Revoked_External_Failed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Integration_Revoked_External_Failed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Zugriff auf die Integration ${i?.provider} wurde lokal entzogen, das Widerrufen auf Seite von ${i?.provider} ist jedoch fehlgeschlagen. Bitte die Verbindung prüfen.`)
	return /** @type {LocalizedString} */ (`Access to the ${i?.provider} integration was revoked locally, but revoking it on the ${i?.provider} side failed. Check the connection.`)
});